import Parameter from '../parameter/Parameter';
import { BudgetLineParameterDto } from 'api/budgets/models/BudgetLineParameterDto';
import { BudgetLineDto } from 'api/budgets/models/BudgetDto';
import { Row, Col } from 'react-bootstrap';
import { ParameterSectionParameterType, ParameterSectionType } from 'common/components/parametersSections/models';

interface Props {
    parameters: BudgetLineParameterDto[];
    level: number;
    line: BudgetLineDto;
    disabled: boolean;
    highlightParameterKeys?: string[];
}

const isFullWidth = (parameter: BudgetLineParameterDto): boolean => {
    if (parameter.type !== ParameterSectionType.PARAMETER) return true;
    return [
        ParameterSectionParameterType.TEXT,
        ParameterSectionParameterType.PRODUCTS,
        ParameterSectionParameterType.IMAGES,
    ].includes(parameter.parameterType!);
};

function ParametersList({ parameters, line, level, disabled, highlightParameterKeys }: Props): JSX.Element | null {
    return (
        <Row>
            {parameters.map((parameter, i) => (
                <Col
                    key={i}
                    sm={12}
                    md={12}
                    lg={isFullWidth(parameter) ? 12 : 6}
                    xl={isFullWidth(parameter) ? 12 : 4}
                    xxl={isFullWidth(parameter) ? 12 : 3}
                >
                    <Parameter
                        parameter={parameter}
                        level={level}
                        line={line}
                        disabled={disabled}
                        highlightParameterKeys={highlightParameterKeys}
                    />
                </Col>
            ))}
        </Row>
    );
}

export default ParametersList;
